import { shouldShowBidPrices, type Bid } from '../../domain/Bid'
import { BookingType, getRatePerMileFromLoadOffer, type LoadOffer } from '../../domain/LoadOffer'
import { Columns, Footer, Stops, Wrapper } from './LoadSummary.styles'
import { LoadSummaryBidPrice } from './LoadSummaryBidPrice'
import { LoadSummaryCommodity } from './LoadSummaryCommodity'
import { LoadSummaryEquipment } from './LoadSummaryEquipment'
import { LoadSummaryMiles } from './LoadSummaryMiles'
import { LoadSummaryRate } from './LoadSummaryRate'
import { LoadSummaryStop } from './LoadSummaryStop'

type LoadSummaryProps = {
  bookingType?: BookingType
  loadOffer: LoadOffer
  price?: number
  bid?: Bid | null
}

export function LoadSummary({
  bookingType = BookingType.BookNow,
  loadOffer,
  price,
  bid,
}: LoadSummaryProps): React.JSX.Element {
  const { commodity, dimensions, equipmentType, intermodal, mileage, stops, weight } = loadOffer
  const ratePerMile = getRatePerMileFromLoadOffer(loadOffer, price)
  const showBidPrices = shouldShowBidPrices(bookingType)

  return (
    <Wrapper>
      {showBidPrices && bid && <LoadSummaryBidPrice bid={bid} />}
      <Stops>
        {stops.map(stop => (
          <LoadSummaryStop key={stop.stopIndex} intermodal={intermodal} stop={stop} />
        ))}
      </Stops>
      <Columns>
        <LoadSummaryEquipment equipmentType={equipmentType} intermodal={intermodal} />
        <LoadSummaryCommodity commodity={commodity} dimensions={dimensions} weight={weight} />
      </Columns>
      <Footer>
        <LoadSummaryMiles mileage={mileage} />
        {price && (
          <LoadSummaryRate bookingType={bookingType} price={price} ratePerMile={ratePerMile} />
        )}
      </Footer>
    </Wrapper>
  )
}
